/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BusinessIntelligenceBiReportingComponent } from './BusinessIntelligenceBiReportingComponent'
export type InteractionRequest = {
  data: {
    professional?: number | string
    type: InteractionRequest.type
    company?: number | string
    department?: number | string
    location?: number | string
    vacancy?: number | string
    initiator?: InteractionRequest.initiator
    BusinessIntelligence?: BusinessIntelligenceBiReportingComponent
    reason?: string
    autoInteract?: boolean
  }
}
export namespace InteractionRequest {
  export enum type {
    INTERESTED = 'interested',
    PUBLIC = 'public',
    DENIED = 'denied',
  }
  export enum initiator {
    PROFESSIONAL = 'professional',
    COMPANY = 'company',
    DEPARTMENT = 'department',
    LOCATION = 'location',
    VACANCY = 'vacancy',
  }
}
